import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';
import PaymentsRibbon from 'rebook/apps/payments/components/PaymentsRibbon';
import { SUBSCRIPTION_TYPES } from 'rebook/apps/payments/constants';

import styles from './style.scss';


const SubscriptionTypeTitle = ({ subscriptionType, hasGift, extraClassName, ribbonContainerExtraClassName }) => {
  let subscriptionTypeTitle = SUBSCRIPTION_TYPES[subscriptionType.toUpperCase()].NOM;

  if (hasGift) {
    subscriptionTypeTitle = `${subscriptionTypeTitle} в&nbsp;подарок`;
  }

  return (
    <div className={classNames(
      extraClassName,
      styles.subscriptionType,
      subscriptionType === 'pro' || subscriptionType === 'audio' ? 'themePremium' : 'themeStandard',
    )}>
      <div className={styles.subscriptionType}>
        <div className="title-2" dangerouslySetInnerHTML={{ __html: subscriptionTypeTitle }} />
      </div>
      <div className={styles.subscriptionTypeIcon}>
        {(subscriptionType === 'pro' || subscriptionType === 'audio')
          ? <SubscriptionIcon type="premium" extraClassName={styles.subscriptionTypeIconImage} />
          : <SubscriptionIcon type="standard" extraClassName={styles.subscriptionTypeIconImage} />
        }
        {hasGift &&
          <span className={styles.subscriptionTypeIconGift} />
        }
        {subscriptionType === 'audio' && (
          <div className={classNames(styles.ribbonContainer, ribbonContainerExtraClassName)}>
            <PaymentsRibbon size="small" />
          </div>
        )}
      </div>
    </div>
  );
};

SubscriptionTypeTitle.defaultProps = {
  hasGift: false,
  ribbonContainerExtraClassName: '',
  subscriptionType: 'standard',
};

SubscriptionTypeTitle.propTypes = {
  extraClassName: PropTypes.string,
  ribbonContainerExtraClassName: PropTypes.string,
  hasGift: PropTypes.bool,
  subscriptionType: PropTypes.string.isRequired,
};

export default SubscriptionTypeTitle;
